import { render, staticRenderFns } from "./modal-tos-page-imprint-text.vue?vue&type=template&id=7f7765fe"
import script from "./modal-tos-page-imprint-text.vue?vue&type=script&lang=js"
export * from "./modal-tos-page-imprint-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports